import { strapiFetch } from '../../../entities/@api/Strapi';
import { UrgentBannerResponse } from '../../../entities/@blocks/UrgentBanner/UrgentBanner';
import { generateUrgentBannerQuery } from '../../../entities/@blocks/UrgentBanner/UrgentBannerRequest';
import { transformToUrgentBanner } from '../../../entities/@blocks/UrgentBanner/UrgentBannerTransformers';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import { ReduxFetchAction } from '../../defaults';
import {
    setError,
    setHasFetched,
    setIsLoading,
    setIsSuccessful,
    setUrgentBanner,
} from './urgentBannerSlice';

export const fetchUrgentBanner: ReduxFetchAction = () => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setHasFetched(false));
    dispatch(setIsSuccessful(false));
    dispatch(setError(''));
    dispatch(setUrgentBanner(undefined));

    try {
        const queryString = generateUrgentBannerQuery();

        const urgentBannerResponse = await strapiFetch<UrgentBannerResponse>(
            `/urgent-banner?${queryString}`,
        );

        if (!isFetchResultSuccessful(urgentBannerResponse)) {
            dispatch(setError(urgentBannerResponse.error));
            return;
        }

        const { data } = urgentBannerResponse.data;

        const urgentBanner = data?.urgentBannerInfo.length
            ? transformToUrgentBanner(data)
            : undefined;

        dispatch(setUrgentBanner(urgentBanner));
    } catch (error) {
        console.error('[fetchUrgentBanner]', error);
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setHasFetched(true));
    }
};
